import { Address, Scalars } from '../../types/generated';
import { apiMutate } from '../../utils/mutation';
import { updateAddressMutation } from '../../mutations/address';
import ServiceConfigs from '../../config';
import { useAddressBook, useShowAddress } from './index';
import { useFulfillmentSettings } from '../../../contexts';

type UseUpdateAddressType = ({
  addressId,
}: {
  addressId: Scalars['ID'];
}) => ({
  areaId,
  street,
  unitType,
  unitNo,
  block,
  building,
  floor,
  avenue,
  notes,
  lng,
  lat,
}: {
  areaId: Scalars['Int'];
  street: string;
  unitType: string;
  unitNo: string;
  block?: string;
  building?: string;
  floor?: string;
  avenue?: string;
  notes?: string;
  lng?: string;
  lat?: string;
}) => Promise<Partial<Address>>;

const useUpdateAddress: UseUpdateAddressType = ({ addressId }) => {
  const { area } = useFulfillmentSettings();
  const { data: addressBook, mutate: mutateAddressBook } = useAddressBook({ areaId: area?.id });
  const { mutate: mutateUserAddressDetails } = useShowAddress({
    addressId,
  });
  const useDeliveryzonesMs = ServiceConfigs?.useDeliveryzonesMs;

  return variables =>
    apiMutate({
      mutation: updateAddressMutation,
      variables: addressId ? { addressId, ...variables, subdomain: ServiceConfigs.getSubDomain() } : null,
      requestHeaders: { ...ServiceConfigs.getAuthorizationHeader() },
      handler: (res: any) => res?.updateAddress,
    }).then((updatedAddress: Address) => {
      const updatedAddresses = addressBook?.addresses.map(address =>
        address.id === updatedAddress.id
          ? { ...updatedAddress, covered: useDeliveryzonesMs ? true : updatedAddress.covered }
          : address,
      );
      mutateAddressBook({ ...addressBook, addresses: [...updatedAddresses] }, false);
      mutateUserAddressDetails(updatedAddress, false);
      return updatedAddress;
    });
};

export default useUpdateAddress;
